import { COLUMN_ACCESS, COLUMN_BUILDING, COLUMN_CATEGORY, COLUMN_COMPANY, COLUMN_CONTROLLER, COLUMN_DATE, COLUMN_DATE_TIME, COLUMN_DEPARTMENT, COLUMN_DEVICE, COLUMN_DIRECTION, COLUMN_DISPLAY_NAME, COLUMN_DOOR, COLUMN_EVENT, COLUMN_FIRST_NAME, COLUMN_FIXED_ADDRESS, COLUMN_FLOOR, COLUMN_GENDER, COLUMN_LAST_NAME, COLUMN_LOGICAL_ADDRESS, COLUMN_READER, COLUMN_REASON_CODE, COLUMN_SECOND_NAME, COLUMN_SERIAL_ADDRESS, COLUMN_SITE, COLUMN_TAG_CODE, COLUMN_TITLE, COLUMN_TRANSACK_TYPE, COLUMN_ZONE } from "../../constants/column-types";
import { FILTER_BUILDINGS, FILTER_COMPANIES, FILTER_CONTROLLER, FILTER_DATE, FILTER_DEPARTMENTS, FILTER_DOORS, FILTER_EVENTS, FILTER_READERS, FILTER_ZONES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";
import LookupTypes from "../LookupTypes";

const UserTransactionColumn: TableColumn[] = [
    {
        heading: "Date/Time",
        accessor: "dateTime",
        isNumeric: false,
        id: 0,
        sortByName: "trDatetimelocal",
        sortDirection: "asc",
        active: true,
        translationKey: "dateTime",
        columnId: COLUMN_DATE_TIME,
    },
    {
        heading: "Event",
        accessor: "eventType",
        isNumeric: false,
        id: 1,
        sortByName: "eventType.nameOriginal",
        sortDirection: "asc",
        active: true,
        lookupName: "eventType.nameOriginal",
        searchOnName: "eventType.id",
        translationKey: "event",
        columnId: COLUMN_EVENT,
        filterId: FILTER_EVENTS,
        settingDataName: 'eventType'
    },
    {
        heading: "Master Controller",
        accessor: "masterController",
        isNumeric: false,
        id: 2,
        sortByName: "trCtrlName",
        lookupName: "controller.devName",
        searchOnName: "controller.id",
        sortDirection: "asc",
        active: true,
        translationKey: "masterController",
        columnId: COLUMN_CONTROLLER,
        filterId: FILTER_CONTROLLER,
        settingDataName: 'deviceImprox'
    },
    {
        heading: "Reader",
        accessor: "reader",
        isNumeric: false,
        id: 3,
        sortByName: "trDevName",
        lookupName: "terminal.devName",
        searchOnName: "terminal.id",
        sortDirection: "asc",
        active: false,
        translationKey: "reader",
        columnId: COLUMN_READER,
        filterId: FILTER_READERS,
        settingDataName: 'deviceImprox'
    },
    {
        heading: "Transaction Type",
        accessor: "transactionType",
        isNumeric: false,
        id: 4,
        sortByName: "transackType.trnName",
        active: false,
        translationKey: "transactionType",
        columnId: COLUMN_TRANSACK_TYPE,
    },
    {
        heading: "Building",
        accessor: "building",
        isNumeric: false,
        id: 5,
        sortByName: "trBuildingName",
        searchOnName: "building.id",
        lookupName: "building.buildingName",
        sortDirection: "asc",
        active: false,
        translationKey: "building",
        columnId: COLUMN_BUILDING,
        filterId: FILTER_BUILDINGS,
        settingDataName: 'building'
    },
    {
        heading: "Floor",
        accessor: "floor",
        isNumeric: false,
        id: 6,
        sortByName: "trFloorName",
        sortDirection: "asc",
        active: false,
        translationKey: "floor",
        columnId: COLUMN_FLOOR,
        settingDataName: 'floors'
    },
    {
        heading: "Date",
        accessor: "dateOnly",
        isNumeric: false,
        id: 7,
        searchOnName: "dateOnly",
        sortByName: "dateOnly",
        sortDirection: "asc",
        active: false,
        translationKey: "date",
        columnId: COLUMN_DATE,
        filterId: FILTER_DATE,
        settingDataName: "date",
        hideLookup: true
    },
    {
        heading: "Zone",
        accessor: "zone",
        isNumeric: false,
        id: 8,
        sortByName: "trZoneName",
        lookupName: "zone.zoneName",
        searchOnName: "zone.id",
        sortDirection: "asc",
        active: false,
        translationKey: "zone",
        columnId: COLUMN_ZONE,
        filterId: FILTER_ZONES,
        settingDataName: 'zone'
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        isNumeric: false,
        id: 9,
        sortByName: "trTagcode",
        sortDirection: "asc",
        active: true,
        translationKey: "cardNumber",
        columnId: COLUMN_TAG_CODE,
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        isNumeric: false,
        id: 10,
        sortByName: "trDevFixedaddr",
        sortDirection: "asc",
        active: false,
        translationKey: "fixedAddress",
        columnId: COLUMN_FIXED_ADDRESS,
    },
    {
        heading: "Logical Address",
        accessor: "logicalAddress",
        isNumeric: false,
        id: 11,
        sortByName: "trSla",
        sortDirection: "asc",
        active: false,
        translationKey: "logicalAddress",
        columnId: COLUMN_LOGICAL_ADDRESS,
    },
    {
        heading: "Serial Address",
        accessor: "serialAddress",
        isNumeric: false,
        id: 12,
        sortByName: "trDevSerial",
        sortDirection: "asc",
        active: false,
        translationKey: "serialAddress",
        columnId: COLUMN_SERIAL_ADDRESS,
    },
    {
        heading: "Door",
        accessor: "door",
        isNumeric: false,
        id: 13,
        sortByName: "trLocName",
        lookupName: "location.locName",
        searchOnName: "location.id",
        sortDirection: "asc",
        active: false,
        translationKey: "door",
        columnId: COLUMN_DOOR,
        filterId: FILTER_DOORS,
        settingDataName: 'location'
    },
    {
        heading: "Reason Code",
        accessor: "reasonCode",
        isNumeric: true,
        id: 14,
        sortByName: "trReasoncode",
        sortDirection: "asc",
        active: false,
        translationKey: "reasonCode",
        columnId: COLUMN_REASON_CODE,
    },
    {
        heading: "Device Type",
        accessor: "deviceType",
        isNumeric: false,
        id: 15,
        sortByName: " unitType.nameOriginal",
        sortDirection: "asc",
        active: false,
        translationKey: "deviceType",
        columnId: COLUMN_DEVICE,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 16,
        active: true,
        searchOnName: LookupTypes.zoneBySiteId,
        lookupName: 'site',
        translationKey: "site",
        columnId: COLUMN_SITE,
    },
    {
        heading: "Direction",
        accessor: "direction",
        isNumeric: false,
        id: 17,
        sortByName: "trDirection",
        sortDirection: "asc",
        active: false,
        translationKey: "direction",
        columnId: COLUMN_DIRECTION,
    }
]

export default UserTransactionColumn;
